"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEARTBEAT = exports.SEARCH_OSCE_STATIONS = exports.OSCE_TOPICS = exports.OSCE_STATION = exports.OSCE_STATIONS = exports.OSCE_MARKSHEET = exports.OSCE_MARKSHEET_WINDOW = exports.OSCE_MARKSHEETS = exports.DASHBOARD_OSCE = exports.OSCE_STATS = void 0;
const client_1 = require("@apollo/client");
const osce_1 = require("../../fragments/osce");
const osce_2 = require("./../../fragments/osce");
exports.OSCE_STATS = (0, client_1.gql) `
  query OsceStats($solo: Boolean!) {
    restricted {
      osceStats(solo: $solo) {
        avgScore
        completed
        total
        types {
          avgScore
          completed
          id
          name
          index
          total
        }
      }
    }
  }
`;
exports.DASHBOARD_OSCE = (0, client_1.gql) `
  query DashboardOsce($solo: Boolean!, $order: Int) {
    restricted {
      dashboardOsce(solo: $solo, order: $order) {
        lastSessionId
        types {
          id
          name
          # user-specific
          completed(solo: $solo)
          total
          avgScore(solo: $solo)
        }
        avgScore
        completed
        total
      }
      user {
        settings {
          productSettings {
            examDate
            nextFeedbackDate
          }
        }
        userProgress {
          marksheetCount
          stationsCount
          daysInCurrentStreak
          daysInPreviousStreak
          daysInLongestStreak
        }
      }
    }
  }
`;
exports.OSCE_MARKSHEETS = (0, client_1.gql) `
  ${osce_2.OSCE_STATION_FIELDS}
  ${osce_1.OSCE_MARKSHEET_FIELDS}
  query OsceMarksheets($solo: Boolean, $days: Int) {
    restricted {
      osceMarksheets(solo: $solo, days: $days) {
        ...OsceMarksheetFields
        osceStation {
          ...OsceStationFields
        }
      }
    }
  }
`;
exports.OSCE_MARKSHEET_WINDOW = (0, client_1.gql) `
  ${osce_2.OSCE_STATION_FIELDS}
  ${osce_1.OSCE_MARKSHEET_FIELDS}
  query OsceMarksheetsWindow($filter: OsceMarksheetWindowFilterInput!) {
    restricted {
      osceMarksheetsWindow(filter: $filter) {
        results {
          date
          result {
            ...OsceMarksheetFields
            correct
            total
            osceStation {
              ...OsceStationFields
              __typename
            }
          }
        }
        score
        total
      }
    }
  }
`;
exports.OSCE_MARKSHEET = (0, client_1.gql) `
  ${osce_2.OSCE_STATION_FIELDS}
  ${osce_1.OSCE_MARKSHEET_FIELDS}
  query OsceMarksheet($id: Int!) {
    restricted {
      osceMarksheet(id: $id) {
        ...OsceMarksheetFields
        osceStation {
          ...OsceStationFields
        }
      }
    }
  }
`;
exports.OSCE_STATIONS = (0, client_1.gql) `
  ${osce_2.OSCE_STATION_FIELDS}
  query OsceStations(
    $solo: Boolean!
    $attempted: Boolean
    $difficulty: [Int!]
    $topicIds: [Int!]
  ) {
    restricted {
      osceStations(
        solo: $solo
        attempted: $attempted
        difficulty: $difficulty
        topicIds: $topicIds
      ) {
        ...OsceStationFields
        lastOsceMarksheetId
        score
      }
    }
  }
`;
exports.OSCE_STATION = (0, client_1.gql) `
  ${osce_2.OSCE_STATION_FIELDS}
  query OsceStation($id: Int!) {
    restricted {
      osceStation(id: $id) {
        ...OsceStationFields
      }
    }
  }
`;
exports.OSCE_TOPICS = (0, client_1.gql) `
  query OsceTopics {
    restricted {
      osceTopics {
        id
        name
        typeId
      }
    }
  }
`;
exports.SEARCH_OSCE_STATIONS = (0, client_1.gql) `
  ${osce_2.OSCE_STATION_FIELDS}
  query SearchOsceStations($search: String!) {
    restricted {
      searchOsceStations(search: $search) {
        ...OsceStationFields
        lastOsceMarksheetId
        score
      }
    }
  }
`;
exports.HEARTBEAT = (0, client_1.gql) `
  query Heartbeat($sessionId: String!) {
    restricted {
      heartbeat(sessionId: $sessionId)
    }
  }
`;
